import IconUser from '../assets/images/icon-user-0.svg';
import IconHome from '../assets/images/icon-home-1.svg';
import Setting from '../assets/images/icon-setting-0.svg';
import Help from '../assets/images/icon-help.svg';
import React from 'react';

type Props = {
  userName: string;
  alarmComponent: React.ReactNode;
  rootPath: string;
  isAdmin: boolean;
  logoutFunc: any;
  setModalOpen: any;
};
//작물, 해양, 산림 헤더
function AuthHeader({ userName, alarmComponent, isAdmin, rootPath, logoutFunc, setModalOpen }: Props) {
  return (
    <div className="hMenuArea">
      <ul className={isAdmin ? 'hMenuList' : 'hMenuList hUserMenuList'}>
        {/* <li>
          <div className="hMenuImg">
            <img
              src={IconUser}
              alt="계정 아이콘"
            />
          </div>
          <div className="hMenuTxt">
            {userName}
            <span>님</span>
          </div>
        </li>
        <li>
          <button
            type="button"
            className="bHeight01 bFillType01"
            onClick={logoutFunc}
          >
            <span>로그아웃</span>
          </button>
        </li>
  */}

        {alarmComponent}

 
        <li>
          {/* <a href={`${rootPath + rootPath}`}>
            <div className="hMenuImg">
              <img
                src={IconHome}
                alt="홈 아이콘"
              />
            </div>
            <div className="hMenuTxt">홈</div>
          </a> */}
        </li>
      </ul>
    </div>
  );
}

export default AuthHeader;
